import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import DirectorForm from '@/components/forms/DirectorForm';
import FormWrapper from '@/components/forms/FormWrapper';
import { DirectorData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateDirector = () => {
  const { directorDataJson, directorIndex } = useLocalSearchParams<{
    directorDataJson: string;
    directorIndex: string;
  }>();
  const [initialDirectorData, setInitialDirectorData] = useState<DirectorData | undefined>(undefined);

  useEffect(() => {
    if (directorDataJson) {
      const parsedDirector = safeJsonParse<DirectorData>(directorDataJson);
      if (parsedDirector) setInitialDirectorData(parsedDirector);
    }
  }, [directorDataJson]);

  return (
    <SafeAreaView style={styles.content} edges={['bottom']}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <DirectorForm
            initialData={initialDirectorData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/edit/npoBoardDirectors',
                params: {
                  directorDataJson: JSON.stringify(data),
                  directorIndex: directorIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },
  container: {
    flex: 1
  }
});

export default AddUpdateDirector;
